import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PodcastsIcon from '@mui/icons-material/Podcasts'

import { PodcastListStyle } from '../styles'
import PodcastModal from '../modals/PodcastModal'
import ResourceDescription from '../shared/ResourceDescription'
import ResourceList from './ResourceList'
import { openExternal } from '../../utils/safeUrl'

const PodcastList = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const secondary = (
        <>
            <ResourceDescription
                description={props.description}
                containerSx={PodcastListStyle.titleContainer}
                typographyProps={{ ...PodcastListStyle.description, gutterBottom: true }}
            />
            <Box sx={PodcastListStyle.secondary}>
                <Typography {...PodcastListStyle.text}>
                    <span style={{"fontWeight":"bold"}}>Series:</span> {props.authors}
                </Typography>
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={PodcastsIcon}
            listStyle={PodcastListStyle}
            modal={<PodcastModal {...props} />}
            title={props.title}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            secondaryContent={secondary}
        />
    )
}

export default PodcastList
